@let referralLogoSrc = this.referralLogoSrc();

<nav>
  @if (!config.isProduction) {
    <span style="position: absolute; top: 8px; left: 8px; opacity: 0.2; z-index: 999999;">
            {{ screenSize() }}
          </span>
  }
  <div
    style="max-width: 1280px; margin-top:0;margin-bottom:0;" fxLayout="row"
    ngClass.gt-xs="px-24 py-12"
    ngClass.xs="px-12 py-8"
    fxLayoutAlign="space-between center"
    fxFill>
    <div
      class="wp-block-group alignwide is-content-justification-space-between is-nowrap is-layout-flex wp-container-core-group-is-layout-2 wp-block-group-is-layout-flex"
      style="padding-top:0;padding-right:0;padding-bottom:0;padding-left:0">
      <div style="margin-right:var(--size-12);" class="wp-block-site-logo">
        <a
        href="{{ logoHref() | appendAppStateParams }}"
        class="logo-link"
        rel="home">
          <img
        width="172" height="30" src="/mindpath-logo.svg"
        class="logo" alt="Mindpath Health" decoding="async">
          @if (referralLogoSrc) {
            <img src="{{referralLogoSrc}}" alt="" decoding="async" class="referral-logo" height="30" >
          }
        </a>
      </div>
      <div
        class="wp-block-group wp-block-mindpath-wizard-header__actions is-content-justification-right is-nowrap is-layout-flex wp-container-core-group-is-layout-1 wp-block-group-is-layout-flex"></div>
    </div>

  </div>
</nav>
<app-lib-progress-bar class="mb-8" [indeterminate]="false" [max]="navSvc.totalStepCount()"
                  [value]="navSvc.currentStep() + 1"></app-lib-progress-bar>
